import React from 'react';
import styled from 'styled-components';
import { ProgressProps } from '../../types';

const ProgressContainer = styled.header`
  margin-bottom: 4rem;
  display: grid;
  justify-content: space-between;
  gap: 1.2rem;
  grid-template-columns: auto auto;
  font-size: 1.8rem;
  color: var(--color-darkest);
  font-family: var(--font-secondary);
`;

const ProgressBar = styled.progress`
  -webkit-appearance: none;
  width: 100%;
  height: 8px;
  grid-column: 1 / -1;

  &::-webkit-progress-bar {
    background-color: var(--color-medium);
    border-radius: 100px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) inset;
  }

  &::-webkit-progress-value {
    background-color: var(--color-theme);
    border-radius: 100px;
    background-image: linear-gradient(45deg, rgba(255,255,255,.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,.15) 50%, rgba(255,255,255,.15) 75%, transparent 75%, transparent);
    background-size: 20px 20px;
  }
`;

const Text = styled.p`
  font-size: 1.6rem;
  font-family: var(--font-secondary);
  color: var(--color-darkest);
`;

const Strong = styled.strong`
  color: var(--color-theme);
  font-weight: 600;
`;

const Progress: React.FC<ProgressProps> = ({ index, numQuestions, answer }) => {
  return (
    <ProgressContainer>
      <ProgressBar
        max={numQuestions}
        value={index + Number(answer !== null)}
      />
      <Text>
        Otázka č. <Strong>{index + 1}</Strong> / {numQuestions}
      </Text>
    </ProgressContainer>
  );
};

export default Progress;
